var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"templateBox"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.list[_vm.textId].title))]),_c('div',{staticClass:"content_box",domProps:{"innerHTML":_vm._s(_vm.list[_vm.textId].content)}}),_c('div',{staticClass:"btn_box",on:{"click":_vm.onCancel}},[_vm._v("我知道了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }